import { h } from 'preact';
import * as BaseComp from 'components/bolt/imageTiles/imageTiles.js';
import { joinClasses } from 'utils/utils';
import { getDynamicData } from 'utils/bolt/dynamicData';

import HTML from 'components/core/html/html';

import s from 'components/bolt/imageTiles/imageTiles.sss';

export default class ImageTiles extends BaseComp.default {

	constructor(props) {
		super(props);

		this.loadData = this.loadData.bind(this);

		this.loadData();
	}

	async loadData() {
		if (typeof window === 'undefined' || !this.props.appData?.options?.cmsManaged) return;
		try {
			this.setState({ loading: true, loadError: false });
			this.useCustomData(await getDynamicData('leadership'));
		} catch {
			this.setState({ loadError: true });
		}
		this.setState({ loading: false });
	}

	useCustomData(dynamicData) {
		if (!dynamicData) return;

		this.setState({
			title: dynamicData.title,
			tiles: dynamicData.imageTiles.map(raw => ({ ...raw, alt: raw?.altText })),
		});
	}

	renderAnnotation(tile) {
		if (!this.props.appData?.options?.cmsManaged) return super.renderAnnotation(tile);
		return (
			<div class={s.annotation}>
				<HTML tag="h3" class={s.name} markdown inline>{tile.title}</HTML>
				<HTML class={s.role} markdown inline>{tile.role}</HTML>
				<HTML class={s.position} markdown inline>{tile.position}</HTML>
				<HTML class={s.department} markdown inline>{tile.department}</HTML>
			</div>
		);
	}

	renderTiles() {
		if (this.state.loading) {
			return <div class={joinClasses(s.tiles, s.loading)} key="tiles" />;
		}
		if (this.state.loadError) {
			return (
				<div class={joinClasses(s.tiles, s.error)} key="tiles">
					<p>Unable to load content. Please try again later.</p>
					<button onClick={this.loadData}>Try again now</button>
				</div>
			);
		}
		return super.renderTiles();
	}
}